import { Input, Label } from '@psyomics/ui-components';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { type FormValues } from './respondent-fields';

type PatientIdFieldProps = {
  readonly register: ReturnType<typeof useForm<FormValues>>['register'];
  readonly disabled?: boolean;
};

const PatientIdField = ({ register, disabled }: PatientIdFieldProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 mt-4">
      <Label htmlFor="patientId">{t('page.professionalReferral.referralRequest.patientIdLabel')}</Label>
      <Input disabled={disabled} id="patientId" {...register('patientId')} />
    </div>
  );
};

export { PatientIdField };
